export default {
  firmMembers: `profile/firmMembers`,
  update: `profile/firmMembers/update`,
  remove: `profile/firmMembers/remove`,
};
